import { colorTokens } from '../tokens/colors.ts';
import { TEXT_COLORS } from '../typography/colors';

const secondaryButtonState = colorTokens.buttonStates.secondary;

/** Figma Dropdown Item tokens (node 393:4707). */
export const dropdownOptionTokens = {
  borderRadius: 4,
  focusOutlineWidth: 2,
  focusOutlineOffset: 0,
  /** Gap between checkbox, icons, and label within an option row, in px. */
  fieldGap: 8,
  /** Gap between a leading icon and its label (view-tab and similar menus). */
  iconLabelGap: 10,
  spacing: {
    cozy: '10px 12px',
    compact: '6px 12px',
  },
  colors: {
    textDefault: TEXT_COLORS['subtext-neutral'],
    textHover: secondaryButtonState.selected.text,
    textSelected: TEXT_COLORS['link-text'],
    textDisabled: TEXT_COLORS.disabled,
    surfaceHover: secondaryButtonState.hover.surface,
    surfaceSelected: secondaryButtonState.selected.surface,
    borderSelected: secondaryButtonState.selected.border,
    borderFocus: secondaryButtonState.selected.border,
  },
} as const;

export type DropdownOptionSpacing = keyof typeof dropdownOptionTokens.spacing;
